function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.2196 11.8047H15.9152C15.3618 11.8047 14.9132 12.2158 14.9132 12.723C14.9132 13.2302 15.3618 13.6414 15.9152 13.6414H23.2196C23.773 13.6414 24.2217 13.2302 24.2217 12.723C24.2217 12.2158 23.773 11.8047 23.2196 11.8047Z",
  fill: "#6F62FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.7627 9.11436C10.8725 9.18175 10.9796 9.25331 11.0838 9.32898C11.9369 9.94882 12.5503 10.8217 12.8114 11.7868C13.003 12.4956 12.8311 13.2323 12.3397 13.8078C12.1059 14.0816 11.8034 14.3086 11.4648 14.4643C11.1087 14.6279 10.7092 14.7145 10.3096 14.7145H5.72327C5.32367 14.7145 4.92416 14.6279 4.56802 14.4643C4.22947 14.3086 3.92693 14.0816 3.69312 13.8078C3.20178 13.2323 3.02986 12.4956 3.22152 11.7867C3.48242 10.8217 4.09595 9.94882 4.949 9.32898C5.05314 9.25331 5.16027 9.18175 5.27006 9.11436C4.96145 8.81432 4.71622 8.47025 4.5407 8.09C4.34342 7.6625 4.24341 7.20949 4.24341 6.74345C4.24341 6.27745 4.34342 5.8244 4.5407 5.3969C4.73082 4.98487 5.00261 4.61525 5.34846 4.29829C5.69432 3.98132 6.09761 3.73222 6.54713 3.55798C7.01354 3.37717 7.50792 3.28547 8.01638 3.28547C8.52484 3.28547 9.01917 3.37713 9.48563 3.55798C9.93519 3.73222 10.3384 3.98132 10.6843 4.29829C11.0302 4.61525 11.302 4.98492 11.4921 5.3969C11.6894 5.8244 11.7894 6.27745 11.7894 6.74345C11.7894 7.20945 11.6894 7.6625 11.4921 8.09C11.3166 8.47025 11.0714 8.81432 10.7627 9.11436ZM9.78535 6.74345C9.78535 5.84811 8.99335 5.12224 8.01638 5.12224C7.03941 5.12224 6.24741 5.84806 6.24745 6.74345C6.24745 8.10917 8.09249 8.86989 9.2055 7.9435C9.5725 7.63806 9.78535 7.19783 9.78535 6.74345ZM5.16672 12.2285C5.07746 12.5587 5.35202 12.8778 5.72323 12.8778H10.3095C10.6807 12.8778 10.9553 12.5587 10.866 12.2284C10.8276 12.0863 10.7764 11.9471 10.713 11.8126C9.98567 10.2683 7.78837 9.70358 6.29175 10.7005C5.73619 11.0706 5.33195 11.6173 5.16672 12.2285Z",
  fill: "#6F62FF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.2196 8.04228H15.9152C15.3618 8.04228 14.9132 8.45344 14.9132 8.96064C14.9132 9.46785 15.3618 9.87901 15.9152 9.87901H23.2196C23.773 9.87901 24.2217 9.46785 24.2217 8.96064C24.2217 8.45344 23.773 8.04228 23.2196 8.04228Z",
  fill: "#6F62FF"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.9152 4.27988H23.2196C23.773 4.27988 24.2217 4.69104 24.2217 5.19824C24.2217 5.70545 23.773 6.11661 23.2196 6.11661H15.9152C15.3618 6.11661 14.9132 5.70545 14.9132 5.19824C14.9132 4.69104 15.3618 4.27988 15.9152 4.27988Z",
  fill: "#6F62FF"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.2802 0H2.71984C1.22009 0 0 1.11825 0 2.49271V15.5073C0 16.8818 1.22014 18 2.71984 18H25.2802C26.78 18 28 16.8818 28 15.5073V2.49271C28 1.1182 26.78 0 25.2802 0ZM25.9959 15.5073C25.9959 15.8695 25.6755 16.1633 25.2802 16.1633H2.71984C2.32454 16.1633 2.00409 15.8695 2.00409 15.5073V2.49271C2.00409 2.13042 2.32454 1.83673 2.71984 1.83673H25.2802C25.6755 1.83673 25.9959 2.13042 25.9959 2.49271V15.5073Z",
  fill: "#6F62FF"
});

var SvgGeneral = function SvgGeneral(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 30 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGeneral, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/general.adbfdf53.svg";
export { ForwardRef as ReactComponent };